var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { services } from '@quandis/qbo4.ui';
import { RestApiService } from '@quandis/qbo4.ui';
import { QboFormElement } from '@quandis/qbo4.ui';
const ssnMap = new Map();
ssnMap.set('defaultLayout', (component) => {
    return html `<div slot="content" class="${component.slotClass}">
        <input type="text" ?disabled=${component.disabled} class="${component.inputClass}" name="${component.inputName}" value="${component.data?.['USSSN']}"/>
        <div><span style="cursor:pointer;" @click="${component.toggleSSN}" class="${component.spanClass}" title="${component.titleShowText}">
            <svg class="show"><use href="/ui/images/qbo-icons.svg#eye"></svg>
            <svg class="hide" style="display:none;"><use href="/ui/images/qbo-icons.svg#eye-slash"></svg>
        </span></div>
    </div>`;
});
let QboSSN = class QboSSN extends QboFormElement {
    constructor() {
        super(...arguments);
        this.apiEndpoint = 'qbo';
        this.disabled = true;
        this.editMode = false;
        this.event = 'click';
        this.imageClassShow = 'qbo-icon-eye';
        this.imageClassHide = 'qbo-icon-eye-slash';
        this.inputClass = 'qbo-sm';
        this.inputName = 'USSSN';
        this.selectorImage = 'svg';
        this.selectorInput = 'input';
        this.selectorSpan = 'span';
        this.show = false;
        this.slotClass = 'qbo-input-group';
        this.spanClass = 'qbo-input-group-text qbo-pointer';
        this.titleMaskText = 'Mask';
        this.titleShowText = 'Show';
        this.type = 'defaultLayout';
        this.url = 'contact/UnmaskSSN';
        this.renderInHost = true;
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    async toggleSSN() {
        this.show = !this.show;
        if (this.show) {
            const service = services.container.isRegistered(this.apiEndpoint)
                ? services.container.resolve(this.apiEndpoint) : new RestApiService(this.apiEndpoint);
            const json = await service.fetch(`${this.url}?ID=${this.data?.['ContactID']}`);
            this.renderRoot.querySelectorAll(`${this.selectorInput}`).forEach(input => {
                if (input instanceof HTMLInputElement
                    && json?.ContactCollection?.length > 0
                    && json.ContactCollection[0].USSSN != null
                    && json.ContactCollection[0].USSSN.length == 9) {
                    const ssn = json.ContactCollection[0].USSSN;
                    input.value = `${ssn.substring(0, 3)}-${ssn.substring(3, 5)}-${ssn.substring(5, 9)}`;
                    if (this.editMode)
                        input.disabled = false;
                    this.renderRoot.querySelectorAll(`${this.selectorSpan}`).forEach(span => {
                        span.setAttribute('title', `${this.titleMaskText}`);
                    });
                    this.renderRoot.querySelectorAll(`${this.selectorImage}.show`).forEach(i => {
                        i.style.display = 'none';
                    });
                    this.renderRoot.querySelectorAll(`${this.selectorImage}.hide`).forEach(i => {
                        i.style.display = '';
                    });
                }
                else {
                    this.show = !this.show;
                }
            });
        }
        else {
            this.renderRoot.querySelectorAll(`${this.selectorInput}`).forEach(input => {
                if (input instanceof HTMLInputElement) {
                    input.value = `${this.data?.['USSSN']}`;
                    if (this.editMode)
                        input.disabled = true;
                }
                this.renderRoot.querySelectorAll(`${this.selectorSpan}`).forEach(span => {
                    span.setAttribute('title', `${this.titleShowText}`);
                });
                this.renderRoot.querySelectorAll(`${this.selectorImage}.show`).forEach(i => {
                    i.style.display = '';
                });
                this.renderRoot.querySelectorAll(`${this.selectorImage}.hide`).forEach(i => {
                    i.style.display = 'none';
                });
            });
        }
    }
    render() {
        return html `<slot>${ssnMap.has(this.type) ? ssnMap.get(this.type)(this) : null}</slot>`;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "apiEndpoint", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboSSN.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboSSN.prototype, "editMode", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "event", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "imageClassShow", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "imageClassHide", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "inputClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "inputName", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "selectorImage", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "selectorInput", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "selectorSpan", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboSSN.prototype, "show", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "slotClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "spanClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "titleMaskText", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "titleShowText", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboSSN.prototype, "type", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSSN.prototype, "url", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboSSN.prototype, "renderInHost", void 0);
QboSSN = __decorate([
    customElement('qbo-ssn')
], QboSSN);
export { QboSSN };
